export interface DefaultQueryParameters {
  [key: string]: string | number;
}

export type SerializableParameters =
  | string[][]
  | Record<string, string>
  | string;

export type QueryParametersSerializer<T = DefaultQueryParameters> = (
  params: T
) => string;

export const defaultQueryParameterSerializer: QueryParametersSerializer = (
  params
): string => {
  const _params: SerializableParameters = {};

  Object.keys(params).forEach((k: string) => {
    _params[k] = params[k].toString();
  });
  return new URLSearchParams(_params).toString();
};

export const serializeQueryParameters = <T = DefaultQueryParameters>(
  src: string,
  params: T,
  serializer?: QueryParametersSerializer<T>
): string => {
  if (!src) return "";
  const url = new URL(src);

  url.search = serializer
    ? serializer(params)
    : defaultQueryParameterSerializer(
        (params as unknown) as DefaultQueryParameters
      );

  return url.toString();
};
